var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2 mr-0",attrs:{"loading":_vm.loading,"small":"","fab":"","color":"#028489"},on:{"click":_vm.getShipmentData}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("\n    local_printshop\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }